import React from "react";
import {
  Box,
  Text,
  Badge,
  Image,
  VStack,
  HStack,
  Flex,
  Button,
} from "@chakra-ui/react";
import { BIZFLEX_README_INTRODUCTION_URL } from "../../components/common/constants";
import { useBizflexAppUrls } from "../../utils/useBizflexAppUrls";

const ApiGetStarted = () => {
  const { registerUrl } = useBizflexAppUrls();
  const metrics = [
    { value: "500+", label: "Active Businesses" },
    { value: "₦2B+", label: "Processed Monthly" },
    { value: "99.9%", label: "API Uptime" },
  ];

  return (
    <Box
      w="100vw"
      position="relative"
      left="50%"
      right="50%"
      ml="-50vw"
      bg="#131B2A"
      bgImage="url('/assets/api-bg.svg')"
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      py={{ base: "28px", md: "40px" }}
    >
      <Box
        w="100%"
        maxW="1326px"
        mx="auto"
        pt={{ base: "60px", md: "100px" }}
        pb={{ base: "24px", md: "32px" }}
        px={{ base: "24px", md: "80px", lg: "120px" }}
      >
        <VStack spacing="60px" align="center" w="100%">
          {/* Top Section */}
          <VStack spacing="24px" align="center" w="100%" maxW="1200px">
            <Badge
              display="flex"
              alignItems="center"
              gap="8px"
              w="fit-content"
              bg="transparent"
              color="#FFFFFF"
              px="16px"
              py="6px"
              border="1px solid rgba(255, 255, 255, 0.2)"
              borderRadius="20px"
              fontSize="13px"
              fontWeight={500}
            >
              <Image
                src="assets/rocket.svg"
                alt="rocket"
                w="16px"
                h="16px"
              />
              Get Started Today
            </Badge>

            <Text
              fontSize={{ base: "30px", md: "46px", lg: "52px" }}
              fontWeight={600}
              textAlign="center"
              color="#FFFFFF"
              lineHeight="1.2"
            >
              Start Building With BizFlex
            </Text>

            <Text
              fontSize={{ base: "14px", md: "16px", lg: "18px" }}
              textAlign="center"
              color="rgba(255, 255, 255, 0.9)"
              maxW="800px"
              lineHeight="1.6"
            >
              Financial APIs built for African businesses. Power your next
              fintech product, automate your financial operations, and scale
              globally with BizFlex.
            </Text>
          </VStack>

          {/* Action Buttons */}
          <Flex
            direction={{ base: "column", md: "row" }}
            gap="16px"
            w="100%"
            justify="center"
            align="center"
            maxW="800px"
          >
            <Button
              as="a"
              href={BIZFLEX_README_INTRODUCTION_URL}
              target="_blank"
              rel="noopener noreferrer"
              bg="#ffffff"
              borderRadius="12px"
              h="58px"
              w={{ base: "100%", md: "300px" }}
              px="24px"
              color="#131B2A"
              fontWeight={600}
              fontSize="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="10px"
              _hover={{ bg: "#F0F0F0" }}
            >
              <Image
                src="assets/mage_book-fill.svg"
                alt=""
                w="20px"
                h="20px"
              />
              See API Documentation
            </Button>

            <Button
              as="a"
              href={registerUrl}
              bg="#2463EB"
              borderRadius="12px"
              h="58px"
              w={{ base: "100%", md: "300px" }}
              px="24px"
              color="#fff"
              fontWeight={600}
              fontSize="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="10px"
              _hover={{ bg: "#1a4fc7" }}
            >
              <Image
                src="assets/card.svg"
                alt=""
                w="20px"
                h="20px"
              />
              Create a Business Account
            </Button>
          </Flex>

          {/* Divider line + Metrics (line back, minimal gap below it) */}
          <Box w="100%" maxW="1200px">
            <Box
              w="100%"
              maxW="800px"
              mx="auto"
              borderTop="1px solid rgba(255, 255, 255, 0.2)"
            />
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="center"
              align="center"
              gap={{ base: "24px", md: "60px" }}
              w="100%"
              pt={{ base: "16px", md: "20px" }}
            >
            {metrics.map((metric, index) => (
              <VStack key={index} spacing="4px" align="center">
                <Text
                  fontSize={{ base: "32px", md: "40px", lg: "48px" }}
                  fontWeight={600}
                  color={metric.value === "₦2B+" ? "#2463EB" : "#FFFFFF"}
                  textAlign="center"
                  lineHeight="1.2"
                >
                  {metric.value}
                </Text>
                <Text
                  fontSize={{ base: "12px", md: "14px" }}
                  fontWeight={400}
                  color="rgba(255, 255, 255, 0.8)"
                  textAlign="center"
                >
                  {metric.label}
                </Text>
              </VStack>
            ))}
            </Flex>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default ApiGetStarted;

